import { ComponentProps } from 'react';
import { Status } from '../common/components';
import {
  CorporateActionViewQuery,
  CryptoActionViewQuery,
  CryptoTransfersTransactionsQuery,
  CryptoTransfersTransactionStatus,
  FiatTransactionStatus,
  FiatTransactionViewQuery,
  SwapOfferViewQuery,
  TransactionStatus,
  TransactionViewQuery,
} from '@bts-web/data-layer/server';
import {
  SavingsPlanTransactionItemType,
  StakingTransactionItemType,
} from '../transactions';

export const STATUS_COLORS: Record<
  AllTypeTransactionStatus,
  ComponentProps<typeof Status>['visual']
> = {
  CREATED: 'filledNeutralLight',
  EXPIRED: 'filledNeutralDark',
  FAILED: 'filledNeutralDark',
  FINISHED: 'positive',
  CANCELED: 'outlineCancelled',
  PENDING: 'outlineOnHold',
  PROCESSING: 'outlineOnHold',
  IN_PROGRESS: 'outlineOnHold',
  ON_HOLD: 'outlineOnHold',
  REJECTED: 'outlineCancelled',
  REFUNDED: 'positive',
  NOT_CONFIRMED: 'filledNeutralDark', // TODO update the correct color when we have design
  // Fiat transaction statuses
  INITIATED: 'filledNeutralLight',
  APPROVED: 'positive',
  CREDITED: 'positive',
  CANCELLED: 'outlineCancelled',
  MANUAL_REVIEW: 'outlineOnHold',
} as const;

export type CryptoTransfersTransactionsItemType = NonNullable<
  NonNullable<
    NonNullable<
      CryptoTransfersTransactionsQuery['response']['cryptoTransfersTransactions']
    >['edges']
  >[number]
>['node'];

export type CryptoTransfersTransactionsExternalAddressType = NonNullable<
  NonNullable<
    NonNullable<
      NonNullable<
        CryptoTransfersTransactionsQuery['response']['cryptoTransfersTransactions']
      >['edges']
    >[number]
  >['node']
>['externalAddress'];

export type CryptoTransfersTransactionsAssetType = NonNullable<
  NonNullable<
    NonNullable<
      NonNullable<
        CryptoTransfersTransactionsQuery['response']['cryptoTransfersTransactions']
      >['edges']
    >[number]
  >['node']
>['asset'];

export type TransactionViewQueryData = NonNullable<
  TransactionViewQuery['response']['transaction']
>;

export type SwapOfferViewQueryData = NonNullable<
  SwapOfferViewQuery['response']['swapOffer']
>;

export type NonNullableChildrenTransaction = NonNullable<
  SwapOfferViewQueryData['childrenTransactions']
>[number];

export type CryptoActionViewQueryData = NonNullable<
  CryptoActionViewQuery['response']['cryptoAction']
>;

export type CorporateActionViewQueryData = NonNullable<
  CorporateActionViewQuery['response']['corporateAction']
>;

export type FiatTransactionViewQueryData = NonNullable<
  FiatTransactionViewQuery['response']['fiatTransaction']
>;

export type AllTransactionViewQueryData =
  | TransactionViewQueryData
  | CryptoTransfersTransactionsItemType
  | SavingsPlanTransactionItemType
  | StakingTransactionItemType
  | SwapOfferViewQueryData
  | CryptoActionViewQueryData
  | FiatTransactionViewQueryData;

export type AllTypeTransactionStatus =
  | TransactionStatus
  | CryptoTransfersTransactionStatus
  | FiatTransactionStatus;
